module.exports = __webpack_public_path__ + "account/assets/unchecked.85b22f51.svg";